module.exports = __webpack_public_path__ + "img/3.052f10a9.jpg";